import { connect } from "react-redux";
import App from "../App";
// import { loadDataSuccess, setTruck, setViewerApi, setSimulationSelect, setActiveSimulation, setActiveSimulationStep, setActiveSimulationType, setSimulationSidePanelActive, endActiveSimulation, restartActiveSimulation, setPositionReady, goToNextSimulation, setAVSP, setContentOpened, setNextSimulationStep } from "../actions/app";
import *as actions from "../actions/app";
import { AppState } from "types/app";
import { getPosibleDialogTypes, getTruckSimulations, getShowLevers, getBoxActiveStep, getCurrentCounterStep } from "selectors/commonSelectors";
import { bindActionCreators } from "redux";
import { GlobalState } from "reducers";


interface connectProps {
  app: AppState
}

export default connect(
  (state: GlobalState) => {
    return ({
      ...state.app,
      posibleSimulationTypes: getPosibleDialogTypes(state),
      truckSimulations: getTruckSimulations(state),
      showLevers: getShowLevers(state),
      boxActiveStep: getBoxActiveStep(state),
      currentCounterStep: getCurrentCounterStep(state),
      freestyle: state.freestyle
    });
  },
  dispacth => bindActionCreators(actions, dispacth)
)(App)